import React, { useEffect, useState, useContext } from 'react';
import { Form, Button } from 'react-bootstrap';
import { BsSearchHeart, BsArrowsCollapse, BsArrowsExpand, BsEraserFill } from 'react-icons/bs';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';

const Filters = ({ toFilter, filterTxt, handleSetFilterTxt, filterCategory, handleSetFilterCat, filterColor, handleSetFilterColor }) => {
    const [categoryList, setCategoryList] = useState([]);
    const [colorList, setColorList] = useState([]);

    useEffect(() => {
        const categories = new Array;
        const types = new Array;

        for (var i = 0; i < toFilter.length; i++) {
            // make sure there is a type field
            if (!toFilter[i].type) {
                toFilter[i].type = "";
            }

            // split possible categories into seperate lines
            var catList = toFilter[i].categories.split(',');
            for (var c = 0; c < catList.length; c++) {
                catList[c] = catList[c].trim();
                // if category not in array, add
                if (catList[c] && !categories.includes(catList[c])) {
                    categories.push(catList[c])
                }
            }
            // if type not in array, add
            if (toFilter[i].type && !types.includes(toFilter[i].type)) {
                types.push(toFilter[i].type.trim())
            }
        }

        setCategoryList(categories.sort());
        setColorList(types.sort());

    }, [toFilter]);

    const handleTxtChange = (f) => {
        handleSetFilterTxt(f.target.value);
    };

    const handleCategoryChange = (f) => {
        handleSetFilterCat(f.target.value);
    }

    const handleColorchange = (f) => {
        handleSetFilterColor(f.target.value);
    }

    const clearFilters = () => {
        handleSetFilterTxt('');
        handleSetFilterCat('');
        handleSetFilterColor('');
    }

    function ContextAwareToggle({ children, eventKey, callback }) {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <div>
                <Button variant="primary" size='sm' onClick={decoratedOnClick}>
                    <BsSearchHeart /> Zoeken {isCurrentEventKey ? <BsArrowsCollapse /> : <BsArrowsExpand />}
                    {children}
                </Button> {!isCurrentEventKey ? <small>(Filters : {filterTxt ? filterTxt : '-'} / {filterCategory ? filterCategory : '-'} / {filterColor ? filterColor : '-'})</small> :
                    <Button variant="info" size="sm" onClick={clearFilters}> <small> <BsEraserFill /> Geen filters</small> </ Button>}
            </div>
        );
    }

    return (

        <Accordion defaultActiveKey="1">
            <Card>
                <Card.Header>
                    <ContextAwareToggle eventKey="0"></ContextAwareToggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                    <Card.Body>
                        <Form.Control
                            size='sm'
                            type="text"
                            placeholder="Zoek op nummer of naam"
                            value={filterTxt}
                            onChange={handleTxtChange} />
                        <Form.Select size='sm' aria-label="Categorie" value={filterCategory} onChange={handleCategoryChange}>
                            <option value="">Categorie (Alle)</option>
                            {categoryList.map((category) => (
                                <option key={category} value={category}>{category}</option>
                            ))}
                        </Form.Select>
                        <Form.Select size='sm' aria-label="Color" value={filterColor} onChange={handleColorchange}>
                            <option value="">Kleur (Alle)</option>
                            {colorList.map((color) => (
                                <option key={color} value={color}>{color}</option>
                            ))}
                        </Form.Select>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>

    );
};

export default Filters;